import { replaceChildrenWithClones } from "../../../helpers/replaceChildrenWithClones";

export default [
    {
        key: "stoyka__sop_kp",
        extra: (el) => {
            replaceChildrenWithClones(el); // TODO КОСТЫЛЬ
        },
    },
    {
        key: "elektropanel",
        allArray: "allElektropanelStoyka",
        activeArray: "activeElektropanelStoyka",
        position: "top",
    },
];
